import ObjectListController from "./object_list_controller"

export default class ChildPortfoliosObjectListController extends ObjectListController {
  connect() {
    super.connect()
  }

  onItemClick(portfolioAllocation) {
    window.Turbo.visit(
      `${this.itemClickBaseUrlValue}/${portfolioAllocation.portfolio_id}`
    )
  }
}
